module.exports = __webpack_public_path__ + "img/technology1.70ec21aa.png";